import dayjs from 'dayjs';

export const PERIODS = {
  LAST_MONTH: "LAST_MONTH",
  MONTH: "MONTH",
  CUSTOM: "CUSTOM",
};

export const AVAILABLE_PERIODS = [
  {
    id: PERIODS.LAST_MONTH,
    label: "Ultimo mese",
  },
  {
    id: PERIODS.MONTH,
    label: "Mensile",
  },
  {
    id: PERIODS.CUSTOM,
    label: "Personalizzato"
  },
];

export const FREQUENCIES = {
  FIFTEEN_MINUTES: "15m",
  THIRTY_MINUTES: "30m",
  ONE_HOUR: "1h",
  TWO_HOURS: "2h",
  FOUR_HOURS: "4h",
  SIX_HOURS: "6h",
  TWELVE_HOURS: "12h",
  TWENTYFOUR_HOURS: "24h",
};

export const AVAILABLE_FREQUENCIES = [
  {
    id: FREQUENCIES.FIFTEEN_MINUTES,
    label: "15 min",
  },
  {
    id: FREQUENCIES.THIRTY_MINUTES,
    label: "30 min",
  },
  {
    id: FREQUENCIES.ONE_HOUR,
    label: "1 ora",
  },
  {
    id: FREQUENCIES.TWO_HOURS,
    label: "2 ore",
  },
  {
    id: FREQUENCIES.FOUR_HOURS,
    label: "4 ore",
  },
  {
    id: FREQUENCIES.SIX_HOURS,
    label: "6 ore",
  },
  {
    id: FREQUENCIES.TWELVE_HOURS,
    label: "12 ore",
  },
  {
    id: FREQUENCIES.TWENTYFOUR_HOURS,
    label: "1 giorno",
  },
];

export const AVAILABLE_FREQUENCIES_CUSTOM = [
  {
    id: FREQUENCIES.ONE_HOUR,
    label: "1 ora",
  },
  {
    id: FREQUENCIES.TWO_HOURS,
    label: "2 ore",
  },
  {
    id: FREQUENCIES.FOUR_HOURS,
    label: "4 ore",
  },
  {
    id: FREQUENCIES.SIX_HOURS,
    label: "6 ore",
  },
  {
    id: FREQUENCIES.TWELVE_HOURS,
    label: "12 ore",
  },
  {
    id: FREQUENCIES.TWENTYFOUR_HOURS,
    label: "1 giorno",
  },
];

export const AVAILABLE_MONTHS = [
  "Gennaio",
  "Febbraio",
  "Marzo",
  "Aprile",
  "Maggio",
  "Giugno",
  "Luglio",
  "Agosto",
  "Settembre",
  "Ottobre",
  "Novembre",
  "Dicembre",
];

export const AviableYears = () => { 
  const annoInizio = dayjs().year();
  const annoFinale = 2019;

  let anni = [];
  for (let anno = annoInizio; anno >= annoFinale; anno--) {
      anni.push(anno);
  }
  return anni 
};

// export const AVAILABLE_YEARS = [
//   2023,
//   2022,
//   2021,
//   2020,
//   2019,
// ];
